import Wix from './wix-sdk-polyfill';
import { ROOT_ID } from '../constants/dom';

const WATCH_HEIGHT_EVERY_MS = 160;

export const resizeIfHeightChanged = (lastHeight: number) => {
  const component = document.getElementById(ROOT_ID);
  if (component) {
    const height = component.clientHeight;
    if (lastHeight !== height || window.innerHeight !== height) {
      Wix.setHeight(height);
      return height;
    }
  }
  return lastHeight;
};

export const resizeOnHeightChange = () => {
  let lastHeight = 0;
  setInterval(() => {
    lastHeight = resizeIfHeightChanged(lastHeight);
  }, WATCH_HEIGHT_EVERY_MS);
};
